module.exports = __webpack_public_path__ + "img/violet_106.ba20fc34.png";